export const Types = {
  CREATE_TYPE: 'incidentType/CREATE_TYPE',
  UPDATE_TYPE: 'incidentType/UPDATE_TYPE',
  SET_RESULTS: 'incidentType/SET_RESULTS',
  NEXT_RESULTS: 'incidentType/NEXT_RESULTS',
  SET_PAGE_INFO: 'incidentType/SET_PAGE_INFO',
  SET_ERROR_QUERY: 'incidentType/SET_ERROR_QUERY',
  SET_ERROR_MUTATION: 'incidentType/SET_ERROR_MUTATION',
  SET_SUCCESS_QUERY: 'incidentType/SET_SUCCESS_QUERY',
  SET_SUCCESS_MUTATION: 'incidentType/SET_SUCCESS_MUTATION',
  LOAD_QUERY: 'incidentType/LOAD_QUERY',
  LOAD_MUTATION: 'incidentType/LOAD_MUTATION',
  FETCH_TYPES: 'incidentType/FETCH_TYPES',
  GET_TYPES: 'incidentType/GET_TYPES',
  RESET_STATE: 'incidentType/RESET_STATE',
  USER_LOGOUT: 'USER_LOGOUT',
};

const initialState = {
  results: [],
  pageInfo: {},
  load_query: false,
  load_mutation: false,
  error_query: {},
  error_mutation: {},
  success_query: {},
  success_mutation: {},
};

export default function incidentType(state = initialState, action) {
  switch (action.type) {
    case Types.SET_RESULTS:
      return { ...state, results: action.results };
    case Types.NEXT_RESULTS:
      return { ...state, results: [...state.results, ...action.results] };
    case Types.SET_PAGE_INFO:
      return { ...state, pageInfo: action.pageInfo };
    case Types.SET_ERROR_QUERY:
      return { ...state, error_query: action.error };
    case Types.SET_ERROR_MUTATION:
      return { ...state, error_mutation: action.error };
    case Types.SET_SUCCESS_QUERY:
      return { ...state, success_query: action.success };
    case Types.SET_SUCCESS_MUTATION:
      return { ...state, success_mutation: action.success };
    case Types.LOAD_QUERY:
      return { ...state, load_query: action.load };
    case Types.LOAD_MUTATION:
      return { ...state, load_mutation: action.load };
    case Types.RESET_STATE:
    case Types.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function saveType({ data, edit, success, error }) {
  return {
    type: edit === true ? Types.UPDATE_TYPE : Types.CREATE_TYPE,
    data,
    success,
    error,
  };
}

export function fetchTypes({ cursor }) {
  return {
    type: Types.FETCH_TYPES,
    cursor,
  };
}

export function getTypes({ cnpj, success, error }) {
  return {
    type: Types.GET_TYPES,
    cnpj,
    success,
    error,
  };
}

export function resetState() {
  return {
    type: Types.RESET_STATE,
  };
}
